/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { IReferral } from 'app/shared/model/referral.model';
import { ProcedureNoteType } from 'app/shared/model/enumerations/procedure-note-type.model';

export interface IPatientProcedurePlan {
  id?: string;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  notes?: string | null;
  noteType?: keyof typeof ProcedureNoteType;
  procedure?: IPatientProcedure;
  recordedBy?: IDoctor | null;
  referral?: IReferral | null;
}

export const defaultValue: Readonly<IPatientProcedurePlan> = {
  active: false,
};
